import { render, staticRenderFns } from "./CompleteRevisionDialogCpt.vue?vue&type=template&id=77f37f5a&"
import script from "./CompleteRevisionDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./CompleteRevisionDialogCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports